module.exports = __webpack_public_path__ + "img/reference-patagonia.0e595e09.webp";